import React from 'react';
import { s } from '../styles';
import { BulletCard, Callout } from '../atoms';
import { IconDrop, IconSqueeze, IconCheck } from '../icons';

// Screen 4 — The Method (part 1). 3 bullets + a closing callout that
// summarises the day-1 promise.
export function Content({ t }) {
  return (
    <div className="screen-enter">
      <h1 style={s.title} className="screen-enter-child">{t('fl_method1_title')}</h1>
      <div style={s.bulletStack} className="screen-enter-child">
        <BulletCard icon={<IconDrop />} className="stagger-item" style={{ '--stagger-i': 0 }}>
          {t('fl_method1_bullet_1')}
        </BulletCard>
        <BulletCard icon={<IconSqueeze />} className="stagger-item" style={{ '--stagger-i': 1 }}>
          {t('fl_method1_bullet_2')}
        </BulletCard>
        <BulletCard icon={<IconCheck />} className="stagger-item" style={{ '--stagger-i': 2 }}>
          {t('fl_method1_bullet_3')}
        </BulletCard>
      </div>
      <div className="screen-enter-child">
        <Callout>{t('fl_method1_callout')}</Callout>
      </div>
    </div>
  );
}

export function Footer({ t, onNext }) {
  return (
    <button type="button" style={{ ...s.cta, ...s.ctaEnabled }} onClick={onNext}>
      {t('fl_method1_cta')}
    </button>
  );
}
